import React from 'react';
import { Menu } from 'semantic-ui-react';
import clsx from 'clsx';
import ErrorPlaceHolder from '@/components/errors/ErrorPlaceHolder';
import selectors from '@/themes/hooks/selectors';

const LoginErrorPlaceHolder = ({ children, error }) => {
  const { theme } = selectors.useTheme();
  return (
    <>
      <Menu inverted className={clsx('nav fixed no-full-screen', `aridhia-theme-${theme}`)} />
      <ErrorPlaceHolder error={error} className="aridhia-login-error-place-holder">
        {children}
      </ErrorPlaceHolder>
    </>
  );
};

export default LoginErrorPlaceHolder;
